"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoInterceptor = void 0;
var react_1 = require("react");
/**
 * @deprecated
 *
 * This feature is deprecated, see https://github.com/goransh/react-super-context/wiki/Interceptors-deprecated
 *
 * Reduce unnecessary re-renders by wrapping the context's value in a useMemo.
 * If the value is an object, the useMemo's dependencies will be all the values of the object.
 * If the value is an array, the useMemo's dependencies will be the array itself.
 *
 * Requires that the super context factory returns an object or array with a constant amount of values.
 *
 * For this to even work, the values of the object/array must be wrapped in useMemo or useCallback
 * or some other approach so that they do not change on every render.
 *
 * If the object or array contains any functions, make sure to wrap them in useCallback.
 */
function memoInterceptor(value) {
    var deps = typeof value === "object" ? Object.values(value) : value instanceof Array ? value : [value];
    return react_1.useMemo(function () { return value; }, deps);
}
exports.memoInterceptor = memoInterceptor;
